import { ReactElement } from "react"

import CreateHpDeviceForm from "../../../../components/devices/lct/hp/createHpDeviceForm"
import NewHpDeviceVersionProvider from "../../../../components/devices/lct/hp/providers/newHpDeviceVersionProvider"

const NewHpDeviceVersion = (): ReactElement => (
    <NewHpDeviceVersionProvider>
        <CreateHpDeviceForm />
    </NewHpDeviceVersionProvider>
)

export default NewHpDeviceVersion
